// ==========================
// I18N
// ==========================
const B2B_LANG =
  (window.B2B && window.B2B.lang) ||
  (window.location.pathname.indexOf('/en-eu') === 0 ? 'en' : 'ro');

const B2B_T = {
  ro: {
    bonus: (kg) => `Bonus B2B: +${kg}kg`,
    remaining: (kg) => `Mai ai ${kg}kg până la bonus`,
  },
  en: {
    bonus: (kg) => `B2B bonus: +${kg}kg`,
    remaining: (kg) => `${kg}kg left until bonus`,
  },
};

const t = B2B_T[B2B_LANG] || B2B_T.ro;


// ==========================
// INIT GLOBAL
// ==========================
document.addEventListener('DOMContentLoaded', () => {
  initB2B();
  observeCartChanges();
});


// ==========================
// OBSERVER (pentru AJAX cart)
// ==========================
function observeCartChanges() {
  const cartContainer = document.querySelector('#main-cart-items');
  if (!cartContainer) return;

  const observer = new MutationObserver(() => {
    initB2B();
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });
}


// ==========================
// MAIN INIT
// ==========================
function initB2B() {
  if (!window.B2B || !window.B2B.enabled) return;

  const allowedTags = ['mabo_spot', 'mabo_dorbob', 'mabo_amazoniq'];
  const customerTags = window.B2B.customerTags || [];

  const isEligible = allowedTags.some(tag => customerTags.includes(tag));
  if (!isEligible) return;

  initProductPageBonus();
  initCartPageBonus();
  translateCartProperties();
  translateCartProperties();
}


// ==========================
// HELPER - KG PARSER
// ==========================
function getKgFromText(value) {
  if (!value) return 0;

  value = value.toLowerCase().replace(',', '.');

  const gramsMatch = value.match(/(\d+)\s*(g|gr)/);
  if (gramsMatch) {
    const grams = parseInt(gramsMatch[1]);

    // ✅ DOAR astea sunt valide
    if (grams === 1000 || grams === 3000) {
      return grams / 1000;
    }

    return 0; // ❌ ignoră restul
  }

  const kgMatch = value.match(/(\d+(\.\d+)?)\s*kg/);
  if (kgMatch) {
    const kg = parseFloat(kgMatch[1]);

    // ✅ DOAR astea sunt valide
    if (kg === 1 || kg === 3) {
      return kg;
    }

    return 0;
  }

  return 0;
}


// ==========================
// HELPER - GĂSEȘTE OPȚIUNEA DE GRAMAJ SELECTATĂ
// (language-agnostic: nu depinde de numele "Gramaj"/"Weight")
// ==========================
function getSelectedWeightInput() {
  // Pill-urile de variantă din Dawn. Valoarea e curată ("1000g", "1kg"),
  // deci getKgFromText filtrează singur care opțiune contează.
  return document.querySelector('.product-form__input--pill input:checked');
}


// ==========================
// PRODUCT PAGE BONUS
// ==========================
function initProductPageBonus() {
  const quantityWrapper = document.querySelector('.product-form__quantity');
  if (!quantityWrapper) return;

  if (quantityWrapper.querySelector('.b2b-bonus')) return;

  const quantityInput = quantityWrapper.querySelector('.quantity__input');
  if (!quantityInput) return;

  const container = document.createElement('div');
  container.className = 'b2b-bonus';
  container.style.marginTop = '10px';
  container.style.fontWeight = '600';
  container.style.color = '#0a7c86';

  quantityWrapper.appendChild(container);

  function updateBonus() {
    const checked = getSelectedWeightInput();
    if (!checked) return;

    const kgPerItem = getKgFromText(checked.value);

    if (kgPerItem === 0) {
      container.innerHTML = '';
      return;
    }

    const qty = parseInt(quantityInput.value || 0);
    const totalKg = qty * kgPerItem;

    const bonusKg = Math.floor(totalKg / 10) * 2;

    if (bonusKg > 0) {
      container.innerHTML = t.bonus(bonusKg);
    } else {
      const remaining = Math.ceil(10 - totalKg);
      container.innerHTML = t.remaining(remaining);
    }
  }

  quantityInput.addEventListener('input', updateBonus);

  quantityWrapper.querySelectorAll('.quantity__button').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(updateBonus, 50));
  });

  // Ascultă orice pill de variantă, indiferent de numele opțiunii
  document.querySelectorAll('.product-form__input--pill input').forEach(el => {
    el.addEventListener('change', () => setTimeout(updateBonus, 50));
  });

  updateBonus();
}


// ==========================
// CART PAGE BONUS
// ==========================
function initCartPageBonus() {
  const cartItems = document.querySelectorAll('.cart-item');
  if (!cartItems.length) return;

  cartItems.forEach(item => {
    if (item.querySelector('.b2b-bonus')) return;

    const gramajEl = item.querySelector('.product-option dd');
    if (!gramajEl) return;

    const gramaj = gramajEl.innerText.trim();
    const kgPerItem = getKgFromText(gramaj);

    if (kgPerItem === 0) return;

    const qtyInput = item.querySelector('.quantity__input');
    if (!qtyInput) return;

    const bonusEl = document.createElement('div');
    bonusEl.className = 'b2b-bonus';
    bonusEl.style.marginTop = '6px';
    bonusEl.style.fontWeight = '600';
    bonusEl.style.color = '#0a7c86';

    gramajEl.parentElement.appendChild(bonusEl);

    function updateBonus() {
      const qty = parseInt(qtyInput.value || 0);
      const totalKg = qty * kgPerItem;

      const bonusKg = Math.floor(totalKg / 10) * 2;

      if (bonusKg > 0) {
        bonusEl.innerHTML = t.bonus(bonusKg);
      } else {
        const remaining = Math.ceil(10 - totalKg);
        bonusEl.innerHTML = t.remaining(remaining);
      }
    }

    qtyInput.addEventListener('input', updateBonus);

    item.querySelectorAll('.quantity__button').forEach(btn => {
      btn.addEventListener('click', () => setTimeout(updateBonus, 50));
    });

    updateBonus();
  });
}

function translateCartProperties() {
  if (B2B_LANG !== 'en') return;

  const map = {
    'Alege beneficiul': 'Choose your benefit',
    'Reducere Cafeaua lunii': 'Coffee of the Month discount',
    '10+2 Kg': '10+2 Kg',
  };

  document.querySelectorAll('.cart-item .product-option').forEach(opt => {
    const dt = opt.querySelector('dt');
    const dd = opt.querySelector('dd');
    if (dt && map[dt.innerText.replace(':', '').trim()]) {
      dt.innerText = map[dt.innerText.replace(':', '').trim()] + ':';
    }
    if (dd && map[dd.innerText.trim()]) {
      dd.innerText = map[dd.innerText.trim()];
    }
  });
}

function translateCartProperties() {
  if (B2B_LANG !== 'en') return;

  const map = {
    // Beneficiu B2B
    'Alege beneficiul': 'Choose your benefit',
    'Reducere Cafeaua lunii': 'Coffee of the Month discount',
    '10+2 Kg': '10+2 Kg',

    // Măcinare — valorile din select
    'Boabe': 'Whole beans',
    'Măcinare pt Ibrik / Cezve': 'Ibrik / Cezve',
    'Măcinare pt Espresso': 'Espresso',
    'Măcinare pt Moka Pot': 'Moka Pot',
    'Măcinare pt Cold Brew': 'Cold Brew',
    'Măcinare pt Aeropress': 'Aeropress',
    'Măcinare pt Filtru de Casa': 'Home filter',
    'Măcinare pt V60': 'V60',
    'Măcinare pt French Press': 'French Press',
  };

  document.querySelectorAll('.cart-item .product-option').forEach(opt => {
    const dt = opt.querySelector('dt');
    const dd = opt.querySelector('dd');

    if (dt) {
      const key = dt.innerText.replace(':', '').trim();
      if (map[key]) dt.innerText = map[key] + ':';
    }
    if (dd) {
      const key = dd.innerText.trim();
      if (map[key]) dd.innerText = map[key];
    }
  });
}